// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** 
 * @file ChatTabs.css
 * @author Simon Tenedero
 * @created 2025-07-07
 * @lastModified 2025-07-07
 * @description Styles for the chat tabs component, including animated gradient border for active tab
 * original tutorial: https://www.youtube.com/watch?v=-VOUK-xFAyk
 */

@property --gradient-angle {
  syntax: "<angle>";
  initial-value: 0deg;
  inherits: false;
}

.active-tab-container {
  background: conic-gradient(
    from var(--gradient-angle),
    #637c54,
    #2d8f85,
    #0e4b50,
    #2d8f85,
    #637c54
  );
  animation: rotation 5s linear infinite;
}

@keyframes rotation {
  0% {
    --gradient-angle: 0deg;
  }
  100% {
    --gradient-angle: 360deg;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/styles/ChatTabs.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;;;;;;;GAOC;EACD,sCAAsC;AACxC;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/** \n * @file ChatTabs.css\n * @author Simon Tenedero\n * @created 2025-07-07\n * @lastModified 2025-07-07\n * @description Styles for the chat tabs component, including animated gradient border for active tab\n * original tutorial: https://www.youtube.com/watch?v=-VOUK-xFAyk\n */\n\n@property --gradient-angle {\n  syntax: \"<angle>\";\n  initial-value: 0deg;\n  inherits: false;\n}\n\n.active-tab-container {\n  background: conic-gradient(\n    from var(--gradient-angle),\n    #637c54,\n    #2d8f85,\n    #0e4b50,\n    #2d8f85,\n    #637c54\n  );\n  animation: rotation 5s linear infinite;\n}\n\n@keyframes rotation {\n  0% {\n    --gradient-angle: 0deg;\n  }\n  100% {\n    --gradient-angle: 360deg;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
